<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Manage Testimonial</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-end pb-2 pt-0"
            >
              <div class="d-md-flex justify-content-between">
                <b-button size="lg" variant="primary btn-mw" @click="addNew()">
                  Add New
                  <i class="fa fa-plus-square"></i>
                </b-button>
              </div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="edit()">Edit</b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
              <template #cell(status)="data">
                <span :class="`badge badge-${data.item.badge}`">
                  {{ data.value }}
                </span>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
export default {
  name: "ManageTestmonial",
  components: {
    BreadCrumb,
  },
  data() {
    return {
      fields: [
        { key: "slNo", label: "Sl No" },
        { key: "testimonialTitle", label: "Testimonial Title" },
        { key: "testimonial", label: "Testimonial" },
        { key: "authorName", label: "Author Name" },
        { key: "authorEmail", label: "Author Email Address" },
        { key: "authorType", label: "Author Type" },
        { key: "status", label: "Status" },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],
      items: [
        {
          slNo: 1,
          testimonialTitle: "THANKS",
          testimonial: "THANKS FOR MAKING LIFE EASY...",
          authorName: "JOYCE SARBAH",
          authorEmail: "jsarbah@yahoo.co.uk",
          authorType: "Registered User",
          status: "Active",
          badge: "success",
        },
        {
          slNo: 2,
          testimonialTitle: "Excellent service - Always!",
          testimonial: "Marvellous...",
          authorName: "Richard Crabbe",
          authorEmail: "emmrichi@yahoo.co.uk",
          authorType: "Registered User",
          status: "Active",
          badge: "success",
        },
        {
          slNo: 3,
          testimonialTitle: "Amazing",
          testimonial:
            "Easy to use. No need to commute all the way to venues...",
          authorName: "Michael Buadi",
          authorEmail: "michaelbuadi@hotmail.com",
          authorType: "Registered User",
          status: "InActive",
          badge: "danger",
        },
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    addNew() {
      this.$router.push({ path: "/manage-testimonial/create" });
    },
    edit() {
      this.$router.push({ path: "/manage-testimonial/edit" });
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            );
          }
        });
    },
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
